import React, { useEffect, useState } from "react";
import { fetchAPI } from "@/utility/NetworkUtils";


const InventoryChits = (props) => {
  const {
    item,
    date,
    event = null,
    onLoad = () => {}
  } = props
  const [ inventoryCount, setInventoryCount ] = useState(null)

  useEffect(() => {
    if(!props.inventoryCount && item) {
      fetchInventoryCount()
      return
    }
    setInventoryCount(props.inventoryCount)
  }, [props.inventoryCount, event])

  fetchInventoryCount = async () => {
    setInventoryCount(null)
    fetchAPI(`/webapi/items/${item.id}/inventory_count?${event ? `event_id=${event.id}` : ""}`, (json)=> {
      if (!json.errors) {
        setInventoryCount(json)
        if(onLoad) {
          onLoad(json)
        }
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  const renderInventoryChit = (label, count, properties = {}) => {
    const special = properties.special
    return (
      <div className={`item-form-inventory-chit `}>
        <div className="item-form-inventory-chit-count" style={{
          background: properties.background,
          color: properties.color
        }}>
          {count}
        </div>
        <div className="item-form-inventory-chit_title">
          { label}
        </div>
      </div>
    )
  }
  if(!inventoryCount) {
    return ""
  }
  return (
    <>
      {renderInventoryChit("Owned", inventoryCount.owned||0, {
        background: inventoryCount.owned <= 0 ? "#E6007359" : null
      })}
      
      {event ? renderInventoryChit("Available", inventoryCount.available||0, {
        background: inventoryCount.available <= 0 ? "#E6007359" : "rgba(102, 0, 51, 0.15)"
      }) : 
      
      renderInventoryChit("In Stock", inventoryCount.currently_available||0, {
        background: inventoryCount.currently_available <= 0 ? "#E6007359" : "rgba(0,187,119,.15)"
      })
      }
      {renderInventoryChit(
        "Ordered",
        inventoryCount.expected_receiving||0,
        {
          color: inventoryCount.expected_receiving <= 0 ? "#BEBEBE" : null,
          background: inventoryCount.expected_receiving > 0 ? "rgba(48, 112, 231, 0.15)" : "rgba(190, 190, 190, 0.15)"
        }
      )}
    </>
  )
}

export default InventoryChits